let ja = {
    "translation" : {
        "datetime" : "M/D(dd) k:mm",
        "date_format" : "YYYY年M月D日",
        "date_day_format" : "YYYY年M月D日(dd)",

        "currency" : "¥",

    }
};

export default ja;